export default {
  pagination: {},
  categories: []
};
